<script lang="ts" setup>
import { computed, onMounted, provide, ref, watch } from "vue";
import jwt_decode from "jwt-decode";
import { useRoute, useRouter } from "vue-router";

const token = ref<string | null>(null);
const decodedToken = ref<object | null>(null);
const router = useRouter();
const route = useRoute();

const isPublic = computed(() => route.path.includes("/ble"));

const providedToken = computed(() => decodedToken.value);

const checkToken = () => {
  token.value = localStorage.getItem("token");
  if (!token.value) {
    if (isPublic.value) return;
    router.push({
      path: "/login",
      state: { redirectTo: route.path },
    });
  } else {
    decodedToken.value = jwt_decode(token.value);
  }
};

watch(() => route.path, checkToken);

onMounted(checkToken);

provide("token", providedToken);
</script>

<template>
  <router-view v-if="isPublic || (token && token.length)" />
</template>
